export default __webpack_public_path__ + "static/media/3d-file.243d0b14.png";